"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

exports.__esModule = true;
exports.useIsRestoring = exports.IsRestoringProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var IsRestoringContext = /*#__PURE__*/_react["default"].createContext(false);

var useIsRestoring = function useIsRestoring() {
  return _react["default"].useContext(IsRestoringContext);
};

exports.useIsRestoring = useIsRestoring;
var IsRestoringProvider = IsRestoringContext.Provider;
exports.IsRestoringProvider = IsRestoringProvider;